import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-tempate-manager",
  templateUrl: "./template-manager.component.html",
  styleUrls: ["./template-manager.component.css"],
})
export class TemplateManagerComponent {
  constructor(private router: Router) { }

  onCardClick(card) {
    this.router.navigate([`/${card}`]);
  }
}
